module.exports = new __parcel__URL__("donkey-kong-country.0242c9f5.jpg").toString();